import { AbstractControl, PristineChangeEvent } from '@angular/forms';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
  Observable,
  of,
  startWith,
  switchMap,
  timer,
} from 'rxjs';
import { IndicatorStatus } from './save-indicator.model';

// TODO: more robust status handling
export function getFormSavingStatus(form: AbstractControl, debounceMs?: number): Observable<IndicatorStatus> {
  return combineLatest([
    form.events.pipe(
      filter((event) => event instanceof PristineChangeEvent),
      map((evt) => !evt.pristine),
      distinctUntilChanged(),
    ),
    form.statusChanges.pipe(startWith(form.status), distinctUntilChanged()),
  ]).pipe(
    debounceTime(debounceMs ?? 0),
    switchMap(([isDirty, formStatus]): Observable<IndicatorStatus> => {
      if (formStatus === 'INVALID') {
        return of(IndicatorStatus.Idle);
      }

      if (isDirty) {
        return of(IndicatorStatus.Saving);
      }

      return merge(of(IndicatorStatus.Saved), timer(2000).pipe(map(() => IndicatorStatus.Idle)));
    }),
  );
}
